import { Close } from '@patrianna-icons/material-icons'
import { useRouter } from 'next/navigation'
import React from 'react'

import classes from './styles.module.scss'

type Props = {
  onClick: () => void
}

const CloseButton = ({ onClick }: Props) => {
  const router = useRouter()

  return <Close onClick={onClick || router.back} className={classes.closeBtn} />
}

export default CloseButton
